export enum UcWebhookType {
  Undefined = 'Undefined',
  PointsUCv1 = 'PointsUCv1',
  FreePlayUCv2 = 'FreePlayUCv2',
  Comps = 'Comps',
  TierCredits = 'TierCredits',
}
